import { useParams } from 'react-router-dom';
import GanttChartContainer from './components/GanttChartContainer';

export default function GanttPage() {
    const { projectId } = useParams();

    if (!projectId) {
        return <div className="p-6 text-sm text-rose-700">잘못된 프로젝트 ID입니다.</div>;
    }

    return (
        <div className="w-full //p-6 space-y-4">
            <div className="flex items-end justify-between mb-2">
                <h1 className="text-lg font-semibold">WBS Gantt Chart</h1>
            </div>
            <GanttChartContainer projectId={projectId} />
        </div>
    );
}
